<template>
  <avue-input-map ref="map" :params="params" :placeholder="placeholder" v-model="values"></avue-input-map>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    params: {
      type: Object,
      default: () => ({
        zoom: 10,
        zoomEnable: true,
        dragEnable: false,
        center: [109.470962, 34.520632]
      })
    },
    placeholder: {
      type: String,
      default: '请选择地图'
    },
  },
  data() {
    return {
      values: []
    };
  },
  watch: {
    value: {
      handler(val) {
        this.values = val.length ? val : [];
      },
      deep: true,
      immediate: true
    },
    values(val) {
      if (val.length && val !== this.value) {
        const [lng, lat, addr] = val;
        console.log(`经度: ${lng}, 纬度: ${lat}, 地址: ${addr}`);
        this.$emit('input', val);
        this.$emit('change', lng, lat, addr);
      }
    },
  }
};
</script>

<style scoped lang="scss">
.pages {
  width: 100%;
  min-height: 100vh;
}
</style>
